import Environment from "../environment";
import Api from "./ApiService";

export const StockService = {
  stock: params => {
    return new Promise((resolve, reject) => {
      return Api.fetch(`${Environment.api}api/items_stock/`, "GET", params)
        .then(rta => {
          resolve(rta);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  localization: epc => {
    return new Promise((resolve, reject) => {
      return Api.fetch(
        `${Environment.api}api/items_stock/localization/`,
        "GET",
        { epc: epc }
      )
        .then(rta => {
          resolve(rta);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  localization_product: itemId => {
    return new Promise((resolve, reject) => {
      return Api.fetch(
        `${Environment.api}api/items_stock/localization-product/`,
        "GET",
        { id: itemId }
      )
        .then(rta => {
          resolve(rta);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  tag_origin_destination: (epc, device_serial) => {
    return new Promise((resolve, reject) => {
      return Api.fetch(
        `${Environment.api}api/items_stock/tag_origin_destination/`,
        "POST",
        { epc: epc, device_serial: device_serial }
      )
        .then(rta => {
          resolve(rta);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  similars: (id, params) => {
    return new Promise((resolve, reject) => {
      return Api.fetch(
        `${Environment.api}api/items_stock/${id}/similars/`,
        "GET",
        params
      )
        .then(rta => {
          resolve(rta);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  downloadAuditoryReport: (location_id, items) => {
    return new Promise((resolve, reject) => {
      return Api.fetchDownload(
        `${Environment.api}api/items_stock/auditory/`,
        "POST",
        { location: location_id, items: items }
      )
        .then(blob => {
          resolve(blob);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  rfids_in_mov_orders: rfids => {
    return new Promise((resolve, reject) => {
      return Api.fetch(
        `${Environment.api}api/items_stock/rfids_in_mov_orders/`,
        "POST",
        { rfids }
      )
        .then(rta => {
          resolve(rta);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  saveAudit: auditData => {
    return new Promise((resolve, reject) => {
      Api.fetch(`${Environment.api}api/audits/`, "POST", auditData)
        .then(rta => {
          if (rta.id) {
            resolve(rta);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },


  getAudits: (params = {}) => {

    if (params.page === undefined) {
      delete params.page;
    }

    return new Promise((resolve, reject) => {
      Api.fetch(`${Environment.api}api/audits/`, "GET", params)
        .then(rta => {
          resolve(rta);
        })
        .catch(error => reject(error));
    });
  },

  getAuditById: auditId => {
    return new Promise((resolve, reject) => {
      Api.fetch(`${Environment.api}api/audits/${auditId}/`, "GET", {})
        .then(rta => {
          resolve(rta);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  updateAuditStatus: (auditId, status) => {
    return new Promise((resolve, reject) => {
      Api.fetch(`${Environment.api}api/audits/${auditId}/`, "PUT", { status })
        .then(rta => {
          resolve(rta);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getAuditDetails: auditId => {
    return new Promise((resolve, reject) => {
      Api.fetch(`${Environment.api}api/audits/${auditId}/details/`, "GET", {})
        .then(rta => {
          resolve(rta);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  updateAuditDetail: (auditId, detailId, data) => {
    return new Promise((resolve, reject) => {
      Api.fetch(`${Environment.api}api/audits/${auditId}/details/${detailId}/`, 'PATCH', data)
        .then(rta => {
          resolve(rta);
        })
        .catch(error => reject(error));
    });
  },

  generateAuditOrder: (data) => {
    return new Promise((resolve, reject) => {
      Api.fetch(`${Environment.api}api/audits/create-auditory-order/`, 'POST', data)
        .then(rta => {
          resolve(rta);
        })
        .catch(error => reject(error));
    });
  },

  downloadAuditDetailsExcel: auditId => {
    return new Promise((resolve, reject) => {
      Api.fetchDownload(
        `${Environment.api}api/audits/${auditId}/download-excel/`,
        "GET",
        {}
      )
        .then(blob => {
          resolve(blob);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  downloadAuditsListExcel: (params) => {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      
      Api.fetchDownload(
        `${Environment.api}api/audits/download-list-excel/?${queryString}`,
        "GET",
        {}
      )
        .then(blob => resolve(blob))
        .catch(error => reject(error));
    });
  },

  validate_tags: (rfids) => {
    return Api.fetch(
      `${Environment.api}api/items_stock/validate-tags/`,
      "GET",
      { rfids: rfids.join(',') }
    );
  },

  updateAuditHeader: (auditId, data) => {
    return new Promise((resolve, reject) => {
      Api.fetch(`${Environment.api}api/audits/${auditId}/`, "PUT", data)
        .then(rta => {
          resolve(rta);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
